export default {
  token: null,
  client: null,
  loginSuccess: null,
  loginError: null,
  registerSuccess: null,
  registerError: null,
  deviceCid: null,
  globalError: null,
  updateError: null,
  updateSuccess: null,
  baseUrl: "https://lk-api.freedom-vrn.ru/lk/api/v1",
  paymentUrl: null,
  payError: null,
  paySuccess: null,
  payStatusError: null,
  payStatusSuccess: null,
  paySum: null,
  reconciliationSuccess: null,
  reconciliationError: null,
  discounts: null,
  payments: null,
  discountsSuccess: null,
  discountsError: null,
  paymentsSuccess: null,
  paymentsError: null,
  balancesSuccess: null,
  balancesError: null,
  balances: null,
  reportsSuccess: null,
  reportsError: null,
  reports: null,
  reportSuccess: null,
  reportError: null,
  groupDiscounts: null,
  invoiceId: null,
  invoiceSuccess: null,
  invoiceError: null,
  loading: false,
  qrId: null,
  isLoadingClientData: false,
  historySelectedYear: -1,
  historySelectedMonth: "Январь",
  historyCurrentClname: "",
  feedbackSuccess: null,
  feedbackError: null,
  isLoadingFeedback: false,
};
